import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var MicrosoftSvg = function MicrosoftSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m2 4.832.007 6.796h.004l8.164-.046h.002l-.004-7.86zm6.674.607-5.173.703.005 3.978 5.17-.03zm2.471 7.104.015 7.932L21.997 22 22 12.561zm1.513 6.628-.01-5.125 7.852.013-.002 6.215zm9.34-7.69V2L11.16 3.577v7.99zm-1.5-1.488-7.838.062v-5.18l7.837-1.141zm-10.322 10.36-8.17-1.12v-6.799l8.163.053zM8.67 13.978l-5.165-.033v3.981l5.168.709z",
    clipRule: "evenodd"
  }));
};
export var Microsoft = function Microsoft(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: MicrosoftSvg
  }));
};